<template>
  <div class="categories">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:left>
        <el-button type="warning" :disabled="loading" @click="allclick"
          >排序</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableDataSortable"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column type="index" width="100" align="center" label="序号">
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="品类名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="品牌/品种"
          prop="tag"
          minWidth="100px"
          align="center"
        >
          <template slot-scope="scope">
            <div class="tag-wrap">
              <div class="tag-box">
                <span
                  v-for="child of scope.row.tags"
                  :key="child.id"
                  class="tag"
                  >{{ child.name }}</span
                >
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="is_audit"
          align="center"
          width="100px"
          label="是否需要审核"
        >
          <template slot-scope="scope">
            {{ scope.row.is_audit == 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="item.prop"
          align="center"
          label="是否显示二级分类"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_show"
              :width="32"
              :active-value="1"
              active-text="显示"
              active-color="#409EFF"
              :inactive-value="0"
              inactive-text="隐藏"
              inactive-color="#C0CCDA"
              @change="openSwitch(scope.$index, scope.row, scope.row.is_show)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-drawer
      title="品类排序"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div>
        <div style="text-align: right; margin-bottom: 20px">
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
        <el-table
          ref="draggableTable"
          :data="tableData"
          row-key="id"
          stripe
          @row-dragged="handleRowDragged"
          height="100%"
          v-loading="loading"
          :border="true"
          :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        >
          <el-table-column type="index" width="100" align="center" label="序号">
          </el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column
            prop="item.prop"
            align="center"
            label="操作"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <i class="el-icon-rank"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>

    <!-- 品类显隐 二次确认 start -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleCloseSwitch"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>您确定要{{ dataState == 0 ? "隐藏" : "显示" }}该品类吗？</span>
      <div v-if="dataState == 0" style="color: red" class="mt-10">
        隐藏后该品类的所有商品将自动下架
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseSwitch">取 消</el-button>
        <el-button type="primary" @click="changeSwitch">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 品类显隐 二次确认 end -->
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import Sortable from "sortablejs";
export default {
  name: "supplier",
  components: {
    Filtersearch,
  },

  data() {
    return {
      dialogVisible: false,
      title: "",
      sortable: "",
      disabledExport: false,
      drawer: false,
      currentPage: 0,
      total: 0,
      loading: false,

      tableData: [],
      tableDataSortable: [],
      source: "",
      from: { source: 1, id: "", name: "" },
      from1: "",
      Filtersearchlist: [
        {
          type: "input",
          name: "品类名称",
          clearable: true,
          model: "name",
          placeholder: "请输入品类名称",
        },
      ],
      dataIndex: "",
      dataRow: {},
      dataState: "",
    };
  },
  created() {
    this.from.source = this.$route.query.source;
    this.source = this.$route.query.source;
    this.from.id = this.$route.query.id;
    this.from1 = JSON.parse(JSON.stringify(this.from));
    this.hqlist();
  },
  watch: {},
  mounted() {},
  beforeDestroy() {
    // 销毁Sortable实例防止内存泄漏
    if (this.sortable) {
      this.sortable.destroy();
    }
  },
  methods: {
    // 打开二次确认 品类显示隐藏
    openSwitch(index, row, state) {
      console.log(index, row, state, "===");
      this.dataIndex = index;
      this.dataRow = row;
      this.dataState = state;
      this.dialogVisible = true;
      this.title = state == 0 ? "品类隐藏" : "品类显示";
    },
    // 关闭二次确认 显示隐藏
    handleCloseSwitch() {
      this.dialogVisible = false;
      this.$set(
        this.tableDataSortable[this.dataIndex],
        "is_show",
        this.dataState == 1 ? 0 : 1
      );
    },
    selectda(e) {
      this.$router.push({
        path: "/categories",
        query: {
          id: e.id,
          source: this.source,
        },
      });
    },
    /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {},
    submit() {
      let arr = this.tableData.map((el) => el.id);

      this.$api.category
        .newcategoriessort({ ids: arr, source: this.source })
        .then((res) => {
          console.log(res, "获取数据");
          this.hqlist();
          this.drawer = false;
        });
    },
    handleRowDragged(newData) {
      this.tableData = newData; // 如果需要更新视图或其他操作可以在这里处理
    },
    initSortable() {
      console.log(this.$refs.draggableTable);
      const el = this.$refs.draggableTable.$el.querySelector(
        ".el-table__body-wrapper tbody"
      );
      this.sortable = Sortable.create(el, {
        onEnd: (evt) => {
          const { newIndex, oldIndex } = evt;
          const movedItem = this.tableData.splice(oldIndex, 1)[0];
          this.tableData.splice(newIndex, 0, movedItem);
        },
      });
    },
    allclick() {
      this.drawer = true;
      this.$nextTick(() => {
        this.initSortable();
      });
    },
    handleClose(done) {
      this.drawer = false;
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    Refresh() {
      Object.assign(this.$data.from, this.$options.data().from);
      this.from.source = this.$route.query.source;
      this.from.id = this.$route.query.id;
      this.from1 = JSON.parse(JSON.stringify(this.from));

      this.hqlist();
    },
    // 修改状态
    changeSwitch() {
      console.log(this.dataState, "state");

      this.$api.category
        .newcategoriesisshow({
          id: this.dataRow.id,
          is_show: this.dataState,
          source: this.$route.query.source,
        })
        .then((res) => {
          if (res.code == 20000) {
            this.$message({
              message:
                this.dataState == 1 ? "该分类已显示！" : "该分类已隐藏！",
              type: "success",
            });
            this.dialogVisible = false;
          } else {
            this.$message({ message: "修改分类状态失败！", type: "error" });
            this.Refresh();
          }
        })
        .catch((err) => {
          this.$set(
            this.tableDataSortable[this.dataIndex],
            "is_show",
            this.dataState == 1 ? 0 : 1
          );
        });
    },
    search(e) {
      this.from = e;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.category.newcategories(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = JSON.parse(JSON.stringify(res.data.child));
        this.tableDataSortable = JSON.parse(JSON.stringify(res.data.child));

        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.categories {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  /** 标签样式 */
  $tag-color: #545454;
  $color: #13ae67;
  .tag-wrap {
    display: flex;
    justify-content: center;
    //   gap: 5px;
    .tag-box {
      // max-width: 200px;
      // height: 35px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 5px;
      // overflow: hidden;
    }
    .tag {
      // height: 100%;
      line-height: 26px;
      padding: 3px 5px;
      border: 0.5px solid rgba($tag-color, 0.3);
      box-sizing: border-box;
      border-radius: 5px;
      color: $tag-color;
      background-color: rgba($tag-color, 0.1);
    }
    .icon {
      padding: 5px;
      border-radius: 5px;
      color: $color;
      cursor: pointer;
    }
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
